<p-toast></p-toast>
<div [ngClass]="{'subaccount-menu': isSubaccount, 'closed-menu': isMobile, 'opened-menu': !isMobile}" #sidebarElement>
  <nav class="sidebar__menu" tdSidebarMenu sidebarHoverClass="sidebar__hovered" sidebarScrollClass="sidebar__scroll"
    [sidebarElement]="sidebarElement">
    <span class="sidebar__menu-hamburger" (click)="setIsMobile()"></span>
    <app-sidebar-menu (onOpenSidebar)="openSidebar($event)"
    (onOpenDataLocationSidebar)="openDataLocationSidebar($event)" class="flex flex-col height-100"></app-sidebar-menu>
  </nav>
  <div class="main-container">
    <main role="main" id="inner-content">
      <header class="top__menu flex justify-between items-center">

        <app-signin-header></app-signin-header>
      </header>
      @if (hasLegacyKey) {
        <div class="legacy-key-alert mx-2 lg:mx-6">
          <p-message severity="warn">
            <div class="flex items-start gap-4">
              <i class="pi pi-exclamation-triangle mt-1"></i>
              <span>
                <span [innerHTML]="'settings_apikeys_legacy_key_alert_message' | i18n" class="me-2"></span> <a [href]="'settings_apikeys_legacy_key_alert_link_href' | i18n" class="inline-block" target="_blank">{{ 'settings_apikeys_legacy_key_alert_link' | i18n }}</a>
              </span>
            </div>
          </p-message>
        </div>
      }
      <!--
      <div class="pb-6 me-2 ms-2 lg:ms-6 lg:me-6" *ngIf="lang === 'en'">
        <p-message severity="warn" styleClass="w-full" [text]="'warning_lang' | i18n ">
        </p-message>
      </div>
      -->
      <router-outlet></router-outlet>
    </main>
    <footer class="text-center">
      <app-signin-footer></app-signin-footer>
    </footer>
  </div>
</div>

